import React from 'react'
import { Chip } from '@mui/material'

import GoogleIcon from '../../../components/icon/GoogleIcon'
import { effectiveLocationWithAllowedLocation } from '../../../helpers/utils'
import { TASK_TYPE_DIC } from '../../constants/constants'
import { getFormattedDate } from '../../details/shared/posDetailsHelpers'
import PosTaskReport from '../PosTaskReport'

export const REPORT_TAB_VALUE = 'pos-task-report'

export const REPORT_TABS = [
  {
    value: REPORT_TAB_VALUE,
    label: 'Tarea en punto de venta',
    icon: 'checklist',
    iconSize: 20,
    filled: true
  }
]

export const REPORT_CLIENT_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_db_ref'
    }
  ]
}

const BOOLEAN_CHIP_SX = {
  minWidth: 48,
  height: 22,
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 800,
  '& .MuiChip-label': {
    px: 1.4
  }
}

export const renderBooleanChip = (value) => (
  <Chip
    label={value ? 'SI' : 'NO'}
    size="small"
    sx={{
      ...BOOLEAN_CHIP_SX,
      backgroundColor: value ? '#E6F6EC' : '#FDE7E5',
      color: value ? '#248A52' : '#D64545'
    }}
  />
)

export const buildPosTaskReportSummaryFields = (activity = {}) => {
  const effectiveLocationLabel = effectiveLocationWithAllowedLocation(
    activity.effective_location,
    activity.has_allowed_location
  )
  const isMandatoryTask =
    activity.is_mandatory_task ?? activity.task_data?.is_mandatory_task ?? false

  return [
    {
      label: 'Fecha de ejecución',
      value: getFormattedDate(activity.created_date)
    },
    {
      label: 'Tipo de tarea',
      value: TASK_TYPE_DIC[activity.task_type] || activity.task_type || '-'
    },
    {
      label: 'Obligatoria',
      value: renderBooleanChip(isMandatoryTask)
    },
    {
      label: 'Descripción',
      value: activity.task_description || activity.task_data?.description || '-'
    },
    {
      label: 'Cantidad de subtareas',
      value: String(activity.task_quantity ?? 0)
    },
    {
      label: 'Dentro de geocerca',
      value:
        effectiveLocationLabel === 'N/A'
          ? effectiveLocationLabel
          : renderBooleanChip(effectiveLocationLabel === 'Sí')
    }
  ]
}

export const formatCapturedPrice = (product = {}) => {
  if (product.out_of_stock) return 'AGOTADO'

  return product.price === undefined || product.price === null || product.price === ''
    ? '-'
    : `$${product.price}`
}

export function PosTaskReportDownloadButton({ activity }) {
  return (
    <div className="pos-task-report-download">
      <PosTaskReport
        data={activity}
        answer={activity.details_survey}
        images={activity.planimetry_images}
        reportDownloads
        buttonClassName="form-header-action-btn form-header-action-btn--primary pos-task-report-download-btn"
        buttonIcon={
          <span className="form-header-action-btn__icon" aria-hidden="true">
            <GoogleIcon name="download_2" size={16} filled />
          </span>
        }
      />
    </div>
  )
}
